import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'

var serviceName = 'culturalResourceService'
var path = '/CulturalResource/'
var isDebug = false

function put (http, culturalResourceDto) {
    loggingService.log(isDebug, serviceName, 'Putting Cultural Resource')
    return http.put(path, culturalResourceDto)
}

function get (http, culturalResourceId) {
    loggingService.log(isDebug, serviceName, `Getting Cultural Resource: ${culturalResourceId}`)
    return http.get(path + 'Get?culturalResourceId=' + culturalResourceId)
}

function search (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'Searching Cultural Resource')
    return http.post(path + 'Search', searchDto)
}

function searchExtended (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'SearchExtended')
    return http.post(path + 'SearchExtended', searchDto)
}

function searchByInvestigation (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'Searching Cultural Resource By Investigation')
    return http.post(path + 'SearchByInvestigation', searchDto)
}

function searchByTrsSiteResults (http, trsResults) {
    loggingService.log(isDebug, serviceName, 'Searching Cultural Resource By TRS Results')
    return http.post(path + 'SearchByTrsSiteResults', trsResults)
}

function searchBySiteNumberRequestId (http, siteNumberRequestId) {
    loggingService.log(isDebug, serviceName, 'searchBySiteNumberRequestId')
    return http.get(path + 'SearchBySiteNumberRequestId?siteNumberRequestId=' + siteNumberRequestId)
}

function getGisSiteData (http, smithsonianNo) {
    loggingService.log(isDebug, serviceName, `Getting GIS Site Data: ${smithsonianNo}`)
    return http.get(path + 'GetGisSiteData?smithsonianNo=' + smithsonianNo)
}

function getConfidentialSetting (http, crId) {
    loggingService.log(isDebug, serviceName, `Getting CR Confidential Setting: ${crId}`)
    return http.get(path + 'GetConfidentialSetting?crId=' + crId)
}

function saveConfidentialSetting (http, confidentialSettingDto) {
    loggingService.log(isDebug, serviceName, `Saving CR Confidential Setting`)
    return http.put(path + 'SaveConfidentialSetting', confidentialSettingDto)
}

function getSegments (http, culturalResourceId) {
    loggingService.log(isDebug, serviceName, `Getting Segments for Cultural Resource: ${culturalResourceId}`)
    return http.get(path + 'GetSegments?culturalResourceId=' + culturalResourceId)
}

function getSegmentHead (http, culturalResourceId) {
    loggingService.log(isDebug, serviceName, `Getting Segment Head for Cultural Resource: ${culturalResourceId}`)
    return http.get(path + 'GetSegmentHead?culturalResourceId=' + culturalResourceId)
}

function generateCsv (http, trsDto, crList) {
    loggingService.log(isDebug, serviceName, 'Generating CSV')
    var genCsvDto = {
        culturalResourceList: crList,
        trsSearchDto: trsDto
    }
    return http.put(path + 'GenerateCsv', genCsvDto)
}

function listHistoricalCulturalResourceTrs (http, culturalResourceId) {
    loggingService.log(isDebug, serviceName, `Listing Historical TRS for CR: ${culturalResourceId}`)
    return http.get(path + 'ListHistoricalCulturalResourceTrs?culturalResourceId=' + culturalResourceId).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.historicalTrsDate = dateService.toDateString(x.historicalTrsDate)
            })
        }
        return response
    })
}

var DistrictOwnershipTypeEnum = {
    SingleOwnership: 1,
    MultipleOwnership: 2,
    MixedOwnership: 3,
    LinearMultiCounty: 4,
    LinearSingleCounty: 5
}

var TribalConsultationEnum = {
    TribalSensitive: 1,
    TraditionalCulturalProperty: 2
}

export default {
    get: get,
    put: put,
    search: search,
    searchExtended: searchExtended,
    searchByInvestigation: searchByInvestigation,
    searchByTrsSiteResults: searchByTrsSiteResults,
    searchBySiteNumberRequestId: searchBySiteNumberRequestId,
    getGisSiteData: getGisSiteData,
    getConfidentialSetting: getConfidentialSetting,
    saveConfidentialSetting: saveConfidentialSetting,
    getSegments: getSegments,
    getSegmentHead: getSegmentHead,
    generateCsv: generateCsv,
    listHistoricalCulturalResourceTrs: listHistoricalCulturalResourceTrs,
    DistrictOwnershipTypeEnum: DistrictOwnershipTypeEnum,
    TribalConsultationEnum: TribalConsultationEnum
}



// WEBPACK FOOTER //
// ./src/services/culturalResourceService.js